import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import { NAME } from "../consts";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";
import { useEffect } from "react";

const useFilter = ({
  filterData,
  setFilterData,
  onCancel,
}: {
  filterData: any;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
  onCancel: () => void;
}) => {
  const isMobile = useIsMobile();

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [NAME]: "",
    },
  });

  useEffect(() => {
    if (filterData) {
      form.reset({ [NAME]: filterData?.[NAME] || "" });
    }
  }, [filterData]);

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
    let _data = removeEmptyFields(data);
    _data = setEmptyFieldsToNull(data);
    setFilterData(_data);
    onCancel();
  };

  const onClear = () => {
    setFilterData(null);
    form.reset({
      [NAME]: ""
    })
  };

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
  };
};

export default useFilter;
